import React, { useRef, useState } from "react";
import { Loader } from "lucide-react";
import Spacing from "../Spacing";
import { notify } from "../../helpers";
import { filterSave } from "../../services/saveFilter";
import { Drawer } from 'vaul';

export default function FilterSaveConfirmationModal(
  { 
    account_id,
    location_id,
    user_id,
    filter_type = "",
    filter = {},
    openModal = false,
    setOpenModal = () =>  {},
    setShowSave = () => {},
    loadFilters = () => {},
    previousScrollPosition = 0,
  }
) {
  const [filterTitle, setFilterTitle] = useState("");
  const [confirmLoader, setConfirmLoader] = useState(false);
  const dropdownRef = useRef(null);

  const saveFilterData = async () => {
    if(filterTitle === "" ) {
      notify("error", "Please provide a valid title");
      return;
    }
    setConfirmLoader(true);
    try {
      const saveFilterDataParams = {
        account_id: account_id,
        location_id: location_id,
        user_id: user_id,
        filter_type: filter_type,
        filter_title: filterTitle,
        filter_data: {
          ...filter,
          page: 1,
        },
      };

      const response = await filterSave(saveFilterDataParams);
      if (response.detail) {
        notify("error", response.detail);
      } else {
        if(response?.data?.status === "success") {
          loadFilters();
          setConfirmLoader(false);
          setShowSave(false);
          handleDrawerClose();
          notify("success", response?.data?.message);
        } else {
          notify("error", response?.data?.message);
        }
      }
    } catch (error) {
      if (error?.response && error?.response?.data && error?.response?.data?.detail) {
        notify("error", error?.response?.data?.detail, 0.5);
      }
    }
  };

  const handleDrawerClose = () => {
    setOpenModal(false);
    window.scrollTo(0, previousScrollPosition);
  };

  return (
    <div style={{ height: "100%" }} ref={dropdownRef}>
      <Drawer.Root open={openModal} onOpenChange={handleDrawerClose}>
        <Drawer.Trigger className="docpro_single_patiant_modal_btn">
        </Drawer.Trigger>
        <Drawer.Portal>
          <Drawer.Overlay className="docpro_drawer_overlay"/>
          <Drawer.Content className="docpro_drawer_content docpro_drawer_style_4 small">
            <Drawer.Title className="sr-only">Save Record</Drawer.Title>
            <Drawer.Description className="sr-only">Save a Filter recorded data</Drawer.Description>
            <div className="docpro_modal_wrap docpro_style_2 docpro_style_auto">
              <div className="docpro_modal">
                <div className="docpro_iconbox_right">
                  <h3 className="docpro_fw_700 docpro_fs_35 docpro_mb_0 text-center">Save filter</h3>
                  <Spacing lg="20" sm="20" />
                  <label className="docpro_fw_500 docpro_primary_color text-left">
                    Filter Name
                  </label>
                  <input 
                    type="text"
                    className="docpro_form_field size_lg  docpro_fs_14"
                    placeholder="ex: healthfirst patients diabetes eye exam pending"
                    required
                    onChange={(e) => setFilterTitle(e.target.value)}
                  />

                  <Spacing lg="32" sm="32" />
                  <div className="docpro_modal_btns" style={{ flexWrap: 'nowrap' }}>
                    <button
                      className="docpro_bordered_btn docpro_fw_600 size_lg w-full"
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        handleDrawerClose();
                      }}
                    >
                      Cancel
                    </button>

                    <button
                      className={`docpro_bordered_btn docpro_fw_600 docpro_filed_btn size_lg w-full`}
                      onClick={() => {saveFilterData()}}
                      disabled={confirmLoader ? true : false}
                    >
                      Save
                      {confirmLoader && (
                        <span className="docpro_loading" style={{ backgroundColor: '#cb1d63' }}>
                          <Loader width={20} height={20} />
                        </span>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    </div>
  );
}
